import React from 'react';
import cn from 'classnames';
import BodyText from "../../../../../ui/Typography/texts/BodyText";
import spacing from '../../../ProductTileComposition.module.scss';
import styles from './ComingSoonMarker.module.scss';
const ComingSoonMarker = ({ isComingSoon, comingSoonLabel, topSpacing, bottomSpacing, size, comingSoonMarkerClassName, }) => {
    if (!isComingSoon)
        return null;
    return (React.createElement(BodyText, { meta: size === 'small' && true, ellipsis: true, className: cn(styles.comingSoonMarker, { [spacing[`${topSpacing}-top`]]: topSpacing }, { [spacing[`${bottomSpacing}-bottom`]]: bottomSpacing }, comingSoonMarkerClassName) }, comingSoonLabel));
};
export default ComingSoonMarker;
//# sourceMappingURL=ComingSoonMarker.js.map